import React, { useEffect, useMemo } from 'react';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import { Tooltip } from 'antd';
import { Icon } from '@/components';
import classNames from 'classnames';
import { barrage } from '@/models';
import { findIndex } from 'lodash-es';
import { SIZE } from '../FontSlider';
interface BarrageItemProps {
  data: any;
}
const widthList = [624, 707, 794, 864, 944];
const BarrageItem: React.FC<BarrageItemProps> = inject(({ store }) => {
  return {
    barrage: store.barrage,
  };
})(
  observer((props: BarrageItemProps) => {
    const { data } = props;
    const width = useMemo(() => {
      const index = findIndex(SIZE, (val) => val === barrage.fontSize);
      return widthList[index];
    }, [barrage.fontSize]);

    const nameWidth = useMemo(() => {
      return barrage.fontSize * 6;
    }, [barrage.fontSize]);

    return (
      <div className={s.container} style={{ maxWidth: width }}>
        <span className={s.nameBox} style={{ width: nameWidth }}>
          <span className={s.name} style={{ fontSize: barrage.fontSize }}>
            {data.name}
          </span>
          <span className={s.dot} style={{ fontSize: barrage.fontSize }}>
            :
          </span>
        </span>
        <span className={s.content} style={{ fontSize: barrage.fontSize }}>
          {data.subtitleContent}
        </span>
      </div>
    );
  })
);

export default BarrageItem;
